import React from 'react';
import { Modal, Button, Space, Typography } from 'antd';

const { Text } = Typography;

/**
 * 点击地图轨迹线后的操作面板
 */
export default function TrackLineActionModal({
  visible,
  memberName,
  kind,
  pointCount = 0,
  isDrawing = false,
  onClose,
  onDownload,
  onExportDrawn,
  onStopDrawing,
  onClearDrawn,
  onHideHistory,
  onHideRealtime,
  canDownload = true,
  canExport = true,
  canRealtime = true,
  canView = true,
  canSendLocation = false,
  onSendLocation
}) {
  const kindLabel = kind === 'realtime' ? '实时绘制轨迹' : '设备历史轨迹';

  return (
    <Modal
      title={`${memberName || '队员'} · 轨迹操作`}
      open={visible}
      onCancel={onClose}
      footer={<Button onClick={onClose}>关闭</Button>}
      destroyOnClose
      centered
      width={400}
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
        {kindLabel}
        {pointCount > 0 ? ` · ${pointCount} 个点` : ''}
        {isDrawing ? ' · 正在续画' : ''}
      </Text>
      <Space direction="vertical" style={{ width: '100%' }} size="small">
        <Button block disabled={!canSendLocation} onClick={onSendLocation}>
          发送位置
        </Button>
        {canDownload && (
          <Button block type="primary" onClick={onDownload}>
            下载轨迹（按时间段）
          </Button>
        )}
        {kind === 'realtime' && (
          <>
            {canExport && (
              <>
                <Button block onClick={() => onExportDrawn?.('gpx')}>
                  导出当前绘制（GPX）
                </Button>
                <Button block onClick={() => onExportDrawn?.('kml')}>
                  导出当前绘制（KML）
                </Button>
              </>
            )}
            {canView && (
              <Button block onClick={onHideRealtime}>
                隐藏该轨迹
              </Button>
            )}
            {canRealtime && isDrawing ? (
              <Button block onClick={onStopDrawing}>
                停止绘制（保留轨迹）
              </Button>
            ) : null}
            {canRealtime && (
              <Button block danger onClick={onClearDrawn}>
                清除绘制轨迹
              </Button>
            )}
          </>
        )}
        {kind === 'history' && canView && (
          <Button block onClick={onHideHistory}>
            隐藏该轨迹
          </Button>
        )}
      </Space>
    </Modal>
  );
}
